document.addEventListener("DOMContentLoaded", () => {
  const row = document.querySelector(".row");
  if (!row) return;

  let container, img, scaleX, scaleY, rafId, timeoutId;
  const zoomLevel = 2;

  const zoomPanel = Object.assign(document.createElement("div"), {
    className: "zoom-panel",
  });
  const crosshair = Object.assign(document.createElement("div"), {
    className: "crosshair",
  });
  row.appendChild(zoomPanel);

  const positionZoomPanel = () => {
    if (!container) return;
    const rect = container.getBoundingClientRect();
    Object.assign(zoomPanel.style, {
      left: `${rect.right + 24}px`,
      top: `${rect.top}px`,
      width: `${rect.width}px`,
      height: `${rect.height}px`,
    });
  };

  const setZoomBackground = () => {
    if (!img) return;
    const zoomSrc = img.dataset.zoomSrc || img.src;
    zoomPanel.style.backgroundImage = `url(${zoomSrc})`;
    zoomPanel.style.backgroundSize = `${img.naturalWidth * zoomLevel}px ${img.naturalHeight * zoomLevel}px`;
    positionZoomPanel();
  };

  // event handlers
  const onEnter = () => {
    if (container && !container.contains(crosshair))
      container.appendChild(crosshair);

    const rect = img.getBoundingClientRect();

    scaleX = (img.naturalWidth * zoomLevel) / rect.width;
    scaleY = (img.naturalHeight * zoomLevel) / rect.height;

    zoomPanel.classList.add("active");
    crosshair.classList.add("active");
    positionZoomPanel();
  };

  const onLeave = () => {
    zoomPanel.classList.remove("active");
    crosshair.classList.remove("active");
  };

  // crosshair and panel math
  const onMove = (e) => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => updateMagnifier(e));
  };

  const updateMagnifier = (e) => {
    const zoomW = zoomPanel.offsetWidth;
    const zoomH = zoomPanel.offsetHeight;
    const containerRect = container.getBoundingClientRect();
    const imgRect = img.getBoundingClientRect();
    const mouseX = e.clientX - imgRect.left;
    const mouseY = e.clientY - imgRect.top;

    const crossW = (imgRect.width * zoomW) / (img.naturalWidth * zoomLevel);
    const crossH = (imgRect.height * zoomH) / (img.naturalHeight * zoomLevel);

    const crossLeft = Math.max(
      0,
      Math.min(mouseX - crossW / 2, imgRect.width - crossW)
    );
    const crossTop = Math.max(
      0,
      Math.min(mouseY - crossH / 2, imgRect.height - crossH)
    );

    crosshair.style.cssText = `
      width:${crossW}px;height:${crossH}px;
      left:${crossLeft + imgRect.left - containerRect.left}px;
      top:${crossTop + imgRect.top - containerRect.top}px;
    `;

    const bgPosX = -(crossLeft + crossW / 2) * scaleX + zoomW / 2;
    const bgPosY = -(crossTop + crossH / 2) * scaleY + zoomH / 2;

    zoomPanel.style.backgroundPosition = `${bgPosX}px ${bgPosY}px`;
  };

  function toggleImgListeners(element, add = true) {
    const method = add ? "addEventListener" : "removeEventListener";
    element?.[method]("mouseenter", onEnter);
    element?.[method]("mouseleave", onLeave);
    element?.[method]("mousemove", onMove);
  }

  const updateActiveImage = () => {
    const newImg = document.querySelector(
      ".swiper-slide.swiper-slide-active .featured-box-sp img"
    );
    if (!newImg) return;

    if (img) toggleImgListeners(img, false);

    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    if (newImg === img) {
      toggleImgListeners(img, true);
      return;
    }

    timeoutId = setTimeout(() => {
      img = newImg;
      container = newImg.closest(".featured-box-sp");

      if (container && !container.contains(crosshair))
        container.appendChild(crosshair);

      const initZoom = () => {
        setZoomBackground();
        toggleImgListeners(img, true);

        if (img.matches(":hover")) {
          onEnter();
        }
      };

      if (img.complete && img.naturalWidth) {
        initZoom();
      } else {
        img.addEventListener("load", initZoom, { once: true });
      }

      timeoutId = null;
    }, 300);
  };

  const observer = new MutationObserver(updateActiveImage);
  let observerActive = false;
  const swiperWrapper = document.querySelector(".swiper-wrapper");

  const throttled = (() => {
    let resizeRaf, scrollRaf;
    return {
      resize: () => {
        if (resizeRaf) cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(handleResize);
      },
      scroll: () => {
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(positionZoomPanel);
      },
    };
  })();

  const handleResize = () => {
    if (window.innerWidth >= 768) {
      if (!observerActive && swiperWrapper) {
        observer.observe(swiperWrapper, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["class"],
        });
        observerActive = true;
      }
      updateActiveImage();
    } else {
      if (observerActive) {
        observer?.disconnect();
        observerActive = false;
      }
      toggleImgListeners(img, false);
    }
  };

  handleResize();
  window.addEventListener("resize", throttled.resize);
  window.addEventListener("scroll", throttled.scroll, {
    passive: true,
  });
  window.addEventListener("beforeunload", () => {
    observer?.disconnect();
  });
});
